export default __webpack_public_path__ + "static/media/pokeball-catch-animation.d8336daa.gif";